import React from "react"
import FaqIndex from "../components/sections/faq/FaqIndex"

function Faq() {
  return (
    <>
      <FaqIndex />
    </>
  )
}

export default Faq
